import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui';
Vue.use(ElementUI)
import '@/assets/js/font.js';
import 'element-ui/lib/theme-chalk/index.css';
import 'swiper/css/swiper.css';
import '@/assets/css/init.css';
import '@/assets/css/wapindex.css';
import axios from './utils/axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

import {removeByIndex,getTime,router_url,screenHeight,hasBtn,isMobile} from './utils/index'

import {get,post,put,export_blob,del} from './api/index'

import pagination from '@/components/pagination'
Vue.component('pagination',pagination);
import header_html from '@/components/header_html'
Vue.component('header_html',header_html);
import footer_html from '@/components/footer_html'
Vue.component('footer_html',footer_html);

Vue.prototype.removeByIndex = removeByIndex
Vue.prototype.isMobile = isMobile
Vue.prototype.getTime = getTime
Vue.prototype.router_url = router_url
Vue.prototype.$get = get
Vue.prototype.$post = post
Vue.prototype.$put = put
Vue.prototype.$export_blob = export_blob
Vue.prototype.$del = del

import vuescroll from "vuescroll";
Vue.use(vuescroll, {
	ops: {
  		vuescroll:{wheelScrollDuration:200 },
		bar: {background: "#c1c1c1", keepShow: true},
		scrollPanel: {scrollingX: false, easing:'easeInQuad'}
	},
	name: 'vueScroll'
});
// localStorage.clear();
import i18n from './utils/i18n/i18n';
var lang = localStorage.getItem('lang') || 'en';
i18n.locale = lang;
import router from './permission' // 权限
new Vue({
	el: '#app',
	router,
	i18n,
	components: {
		App
	},
	template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js